/** i18n-ключі client-валідації полів login (літерали → типобезпечний `t()`). */
export type LoginValidationKey =
  | "auth.errors.validation.emailRequired"
  | "auth.errors.validation.emailInvalid"
  | "auth.errors.validation.passwordRequired";

export interface LoginFieldValidation {
  email: LoginValidationKey | null;
  password: LoginValidationKey | null;
}

/** Прагматичний email-regex (spec §4.3) — не RFC-повний, відсікає очевидно невалідне. */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Client-валідація на сабміті (spec §4.3): email required + формат; password
 * лише непорожній (це login, не signup — без перевірки складності). Чиста
 * функція → тестабельна без монтажу.
 */
export function validateLoginFields(
  email: string,
  password: string,
): LoginFieldValidation {
  const trimmed = email.trim();
  let emailErr: LoginValidationKey | null = null;
  if (!trimmed) {
    emailErr = "auth.errors.validation.emailRequired";
  }
  else if (!EMAIL_RE.test(trimmed)) {
    emailErr = "auth.errors.validation.emailInvalid";
  }

  const passwordErr: LoginValidationKey | null
    = password.length === 0 ? "auth.errors.validation.passwordRequired" : null;

  return { email: emailErr, password: passwordErr };
}
